import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const PaymentCancelPage = () => (
  <main className="min-h-screen bg-[#f1e3eb] flex items-center justify-center px-4 py-20">
    <Card className="max-w-md w-full border-0 shadow-xl" data-testid="payment-cancel-card">
      <CardContent className="p-10 text-center">
        <XCircle className="w-14 h-14 text-[#9dad84] mx-auto mb-6" />
        <h1 className="font-serif text-2xl text-[#3c4a2a] mb-3">Donation Cancelled</h1>
        <p className="text-[#5f6d51] mb-8">
          No charge was made. If you changed your mind, we'd still love your support whenever you're ready.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/donate">
            <Button className="w-full bg-[#5d6b3c] hover:bg-[#3c4a2a] text-white" data-testid="payment-cancel-retry-btn">
              Back to Donate
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full border-[#5d6b3c] text-[#5d6b3c] hover:bg-[#5d6b3c] hover:text-white">
              Return Home
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  </main>
);

export default PaymentCancelPage;
